import axios from '@/utils/axios';

// Types

// API

export default {
	async getAll(): Promise<any[]> {
		return (await axios().get(`/events/`)).data;
	},

	async getSalesOfOne(eventID: number): Promise<any[]> {
		return (await axios().get(`/events/${eventID}/sales`)).data;
	},
};
